import { useToolAccess } from '../hooks/useToolAccess'

/** Audio (ADR 0028/0031): one launch stage opens the AI Audio page, Create audio and the
 *  per-Account Audio tab together. `launched` = open to this login at all; the AI Audio
 *  page also needs its own `access_audio` on at least one Account (the per-Account tab
 *  needs `access_audio_settings`). The backend (GET /auth/me/tools) answers both and
 *  enforces the same. */
export function useVoicesLaunched(): boolean {
  return useToolAccess()?.launched.audio ?? false
}

/** null while loading. */
export function useVoicesPageAccess(): boolean | null {
  const tools = useToolAccess()
  return tools ? tools.usable.audio : null
}
